import React from 'react'
import './_conferma.scss'
import { ReactComponent as Close } from "../../assets/new-icons/close.svg";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as Whatsapp } from "../../assets/new-icons/whatsapp.svg";
import { useSelector } from 'react-redux';
import { ReactComponent as Assistenza } from "../../assets/new-icons/assistenza.svg";

function Conferma({setSeeConferma, mainFunction}) {
    const fullName = useSelector((user) => user.user.info.customer_full_heading)
    const userNameWords = fullName.split(' ').length;
    const splittedName = userNameWords < 3 ? fullName.split(' ').slice(0, -1).join(' ') : fullName.split(' ').slice(0, -2).join(' ')
    const splittedNameLower = splittedName
    const customerCode = useSelector((user) => user.user.info.customer_code);
    const urlWhatsapp = `https://wa.me/393935777481?text=Ciao%20sono%20${splittedNameLower},%20${customerCode}.`
  return (
    <div className='confermaComponent'>
        <div className="confermaComponent-box">
            <p className="main">Confermi questa operazione?</p>
            <div className="confermaComponent-box-flex">
                <div className="confermaComponent-box-flex_box" onClick={() => setSeeConferma(false)}>
                    <button className="red">Annulla <Close /></button>
                </div>
                <div className="confermaComponent-box-flex_box" onClick={() => mainFunction()}>
                    <button className="green">Conferma <ArrowForwardIosIcon/></button>
                </div>
            </div>
        </div>
        <div className="confermaComponent-box-whatsapp" onClick={() => window.open(urlWhatsapp)}>
            <div className="icon">
                <Whatsapp />
            </div>
            <p className="main">Chatta con noi</p>
            <div className="arrow"><ArrowForwardIosIcon/></div>
        </div>
        <div className="confermaComponent-box-assistence" onClick={() => window.open('https://revoluce.zendesk.com/hc/it', { target: '_blank'})}>
            <div className="icon">
                <Assistenza />
            </div>
            <p className="main">Cerca sull'help desk</p>
            <div className="arrow"><ArrowForwardIosIcon/></div>
        </div>
    </div>
  )
}

export default Conferma